<template>
  <a-modal
    :title="title"
    :width="1280"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" :layout="formLayout">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              采销全流程信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="采销全流程名称" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '选择' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                @search="this.tradeProjectSearch"
                @change="handleTradeProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in tradeProjectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedProject">
            <a-form-item label="主体企业" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <h4>{{ selectedProject.host_corporation }}</h4>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedProject">
            <a-form-item label="交易品种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <h4>{{ selectedProject.category }}</h4>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              基础信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="系统编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="系统编号"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input style="width: 70%;" v-decorator="['contract_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="合同号"/>
              <a-button style="margin-left: 5px;" @click="generateContractNumber" :loading="generateLoading">生成合同号</a-button>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input allow-clear placeholder="合同名称" v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="贸易类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-decorator="[
                  'trade_type',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="选择"
                :default-active-first-option="false"
                @change="handleTradeTypeChange"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in tradeTypes">
                  {{ val }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="签订日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['contract_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="签订日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="this.model['type'] === '1' ? '供应商':'客户'" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                mode="multiple"
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                v-decorator="[
                  'client_ids',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="选择"
                :default-active-first-option="false"
                @search="this.clientSearch"
                @change="handleClientChange"
              >
                <a-select-option v-for="d in clientList" :key="d.client_id" :tt="d.client">
                  {{ d.client }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="产品名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['product_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="产品名称" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" allow-clear v-decorator="['count', { rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="数量" :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')">
              </a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="数量单位" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                style="width: 100%"
                placeholder="选择"
                show-search
                :not-found-content="null"
                :default-active-first-option="false"
                :filter-option="filterOption"
                v-decorator="['unit', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit" :label="val">
                  {{ val }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="tradeType !== 1">
            <a-form-item label="贸易术语" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'trade_term',
                  {
                    rules: [
                      { required: tradeType !== 1, message: '请选择贸易术语' },
                    ]
                  },
                ]"
                placeholder="选择"
                show-search
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="(val) in this.$Dictionaries.trade_terms"
                  :value="val"
                  :key="val">
                  {{ val }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="交货地" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['delivery_address', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="交货地"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="最迟交货日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['latest_delivery_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="最迟交货日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="溢装率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number allow-clear v-decorator="['overloading_rate', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="短装率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number allow-clear v-decorator="['shortage_rate', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]"/> %
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              财务信息
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="model['type'] === '1'">
            <a-form-item label="关税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 40%" allow-clear v-decorator="['tariff', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="关税"/>
              <a-select
                style="width: 40%"
                v-decorator="['tariff_type', { rules: [{required: false, message: '请选择' }]}]"
                placeholder="选择"
                allow-clear
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_tax_type">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] === '1'">
            <a-form-item label="消费税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 40%" allow-clear v-decorator="['consumption_tax', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="消费税"/>
              <a-select
                style="width: 40%"
                v-decorator="['consumption_tax_type', { rules: [{required: false, message: '请选择' }]}]"
                placeholder="选择"
                allow-clear
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_tax_type">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] !== undefined">
            <a-form-item label="增值税率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 40%" allow-clear v-decorator="['tax_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/> %
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              商品信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="规格型号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['spec', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="规格型号"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="tradeType !== 1">
            <a-form-item label="HSCode" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['customs_declaration_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="HSCode"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="质量" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" style="margin-left: 10px" @click="addProductParameter">产品参数</a-button>
              <div v-if="otherData.product_parameters.length > 0">
                <a-table
                  bordered
                  :data-source="otherData.product_parameters"
                  :columns="parameterColumns"
                  v-if="this.otherData.product_parameters.length > 0"
                  :pagination="false"
                  key="key">
                  <span slot="serial" slot-scope="text, record, index">
                    {{ index + 1 }}
                  </span>
                  <template slot="action" slot-scope="text, record">
                    <a-popconfirm
                      v-if="otherData.product_parameters.length"
                      title="确定删除?"
                      @confirm="() => onParameterDelete(record.key)"
                    >
                      <a href="javascript:;">删除</a>
                    </a-popconfirm>
                  </template>
                </a-table>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="质量扣款依据" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-textarea v-decorator="['quality_deduction_reason', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="质量扣款依据" :rows="2"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              金额信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="定价方式" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'unit_price_type',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                allow-clear
                @change="unitPriceChange"
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in unit_price_type">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :offset="2" :span="22" v-if="selectedUnitPrice === 1" class="hidden_item">
            <a-row>
              <a-col :span="12">
                <a-form-item label="计价币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-select
                    v-decorator="[
                      'pricing_currency',
                      {
                        rules: [
                          { required: false, message: '请选择' }
                        ],
                      },
                    ]"
                    placeholder="选择"
                    show-search
                    @change="pricingCurrencyChange"
                    option-filter-prop="children"
                    :filter-option="filterOption">
                    <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="收款币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-select
                    v-decorator="[
                      'receive_pricing_currency',
                      {
                        rules: [
                          { required: false, message: '请选择' }
                        ],
                      },
                    ]"
                    placeholder="选择"
                    show-search
                    option-filter-prop="children"
                    @change="receivedPricingCurrencyChange"
                    :filter-option="filterOption">
                    <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number style="width: 50%" allow-clear v-decorator="['unit_price', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="单价"/>
                  <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="单价是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-switch checked-children="是" un-checked-children="否" v-decorator="['is_tax_unit_price', {rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number style="width: 50%" allow-clear v-decorator="['exchange_rate', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="汇率"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number
                    style="width: 50%"
                    allow-clear
                    placeholder="数量"
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    v-decorator="['pricing_count', {rules: [{required: false, message: '必填项，请填写信息'}]}]" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number
                    style="width: 50%"
                    allow-clear
                    placeholder="合同金额"
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    v-decorator="['contract_amount', { rules: [{required: false, message: '必填项，请填写信息'}]}]" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="合同金额是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-switch checked-children="是" un-checked-children="否" v-decorator="['is_tax_contract_amount', {rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
          <a-col :offset="2" :span="22" v-if="selectedUnitPrice === 2" class="hidden_item">
            <a-row>
              <a-col :span="12">
                <a-form-item label="计价币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-select
                    v-decorator="[
                      'pricing_currency',
                      {
                        rules: [
                          { required: false, message: '请选择' }
                        ],
                      },
                    ]"
                    placeholder="选择"
                    show-search
                    @change="pricingCurrencyChange"
                    option-filter-prop="children"
                    :filter-option="filterOption">
                    <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="收款币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-select
                    v-decorator="[
                      'receive_pricing_currency',
                      {
                        rules: [
                          { required: false, message: '请选择' }
                        ],
                      },
                    ]"
                    placeholder="选择"
                    show-search
                    option-filter-prop="children"
                    @change="receivedPricingCurrencyChange"
                    :filter-option="filterOption">
                    <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="升贴水" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number allow-clear v-decorator="['premium_discount', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="升贴水"/>
                  <span style="padding-left: 10px">正数为升水、负数为贴水</span>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="点价费" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number allow-clear v-decorator="['price_fixing_fee', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="点价费"/>
                  <span style="padding-left: 5px" v-if="false">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="定价源" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input allow-clear v-decorator="['pricing_source', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="定价源，例如：ICE布伦特"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="期货合约" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-month-picker
                    v-decorator="['futures_contract', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                    format="YYYY-MM"
                    value-format="yyyy-MM"
                    placeholder="期货合约"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="目前锁价期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-date-picker
                    v-decorator="['lock_up_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                    format="YYYY-MM-DD"
                    placeholder="锁价期限"
                    value-format="yyyy-MM-DD"
                  />
                  <span style="padding-left: 5px">备注：不包含当天</span>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="默认计价期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-range-picker
                    @change="time"
                    format="YYYY-MM-DD"
                    style="width: 100%"
                    v-decorator="['pricing_period', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                    <template slot="dateRender" slot-scope="current">
                      <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                        {{ current.date() }}
                      </div>
                    </template>
                  </a-range-picker>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-row>
                  <a-col :span="12">
                    <a-form-item label="是否可转月" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                      <a-switch checked-children="是" un-checked-children="否" @change="handleTurningMonthChange" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item v-if="isTurningMonth" label="转月费" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                      <a-input-number allow-clear v-decorator="['monthly_transfer_fee', {rules: [{required: isTurningMonth, message: '必填项，请填写信息'}]}]" placeholder="转月费"/>
                      <span style="padding-left: 5px" v-if="false">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-col>
              <a-col :span="24">
                <a-table
                  style="width: 100%"
                  v-if="turningMonthList.length > 0 || isTurningMonth"
                  :data-source="turningMonthList"
                  ref="turningMonthTable"
                  :columns="turningMonthColumns"
                  :pagination="false">
                  <span slot="serial" slot-scope="text, record, index">
                    {{ index + 1 }}
                  </span>
                  <template slot="action" slot-scope="text, record">
                    <a-popconfirm
                      title="确定删除吗?"
                      @confirm="() => onDeleteItem(record.key)"
                    >
                      <a href="javascript:;">删除</a>
                    </a-popconfirm>
                  </template>
                  <template slot="footer">
                    <div style="text-align: center">
                      <a-button @click="addTurningMonth(true)" icon="plus">转月</a-button>
                    </div>
                  </template>
                </a-table>
              </a-col>
              <a-col :span="24">
                <a-form-item label="汇率" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                  <a-select
                    v-decorator="[
                      'exchange_rate_type',
                      {
                        rules: [
                          { required: true, message: '请选择' }
                        ],
                      },
                    ]"
                    placeholder="选择"
                    allow-clear
                    @change="exchangeRateChange"
                    option-filter-prop="children"
                    :filter-option="filterOption">
                    <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.exchange_rate">{{ val }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :offset="1" :span="23" v-if="selectedExchangeRate > 0">
                <a-divider orientation="left" dashed>{{ exchangeRateTitle }}</a-divider>
                <a-form-item label="固定汇率" v-if="selectedExchangeRate === 1" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                  <a-input-number style="width: 60%" allow-clear v-decorator="['fixed_exchange_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
                </a-form-item>
                <a-row v-if="selectedExchangeRate === 2">
                  <a-col :span="10">
                    <a-form-item label="日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                      <a-date-picker
                        v-decorator="['fixed_date_rate', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                        format="YYYY-MM-DD"
                        value-format="yyyy-MM-DD"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item label="汇率定义方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                      <a-input v-decorator="['exchange_rate_definition', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="汇率定义方式" />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-form-item label="其他日期汇率" v-if="selectedExchangeRate === 3" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                  <a-textarea allow-clear v-decorator="['unfixed_date_rate', {rules: [{required: true, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="临时单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number style="width: 50%" allow-clear v-decorator="['unit_price', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="单价"/>
                  <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="单价是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-switch checked-children="是" un-checked-children="否" v-decorator="['is_tax_unit_price', {rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="临时汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number style="width: 50%" allow-clear v-decorator="['temp_exchange_rate', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="临时汇率"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number style="width: 50%" allow-clear v-decorator="['pricing_count', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="数量"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number
                    style="width: 50%"
                    allow-clear
                    placeholder="合同金额"
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    v-decorator="['contract_amount', { rules: [{required: false, message: '必填项，请填写信息'}]}]" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="合同金额是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-switch checked-children="是" un-checked-children="否" v-decorator="['is_tax_contract_amount', {rules: [{required: false, message: '必填项，请填写信息'}]}]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
          <a-col :offset="2" :span="22" v-if="selectedUnitPrice === 3" class="hidden_item">
            <a-row>
              <a-col :span="12">
                <a-form-item label="PACE指数月份" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-month-picker
                    v-decorator="['pace_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                    placeholder="PACE指数月份"
                    format="YYYY-MM"
                    value-format="yyyy-MM-DD"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="升贴水" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number allow-clear v-decorator="['premium_discount', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="升贴水"/>
                  <span style="padding-left: 10px">正数为升水、负数为贴水</span>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="计价币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-select
                    v-decorator="[
                      'pricing_currency',
                      {
                        rules: [
                          { required: false, message: '请选择' }
                        ],
                      },
                    ]"
                    placeholder="选择"
                    show-search
                    @change="pricingCurrencyChange"
                    option-filter-prop="children"
                    :filter-option="filterOption">
                    <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input allow-clear v-decorator="['exchange_rate', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="汇率"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number style="width: 50%" allow-clear v-decorator="['pricing_count', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="数量"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number
                    style="width: 50%"
                    allow-clear
                    placeholder="合同金额"
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    v-decorator="['contract_amount', { rules: [{required: false, message: '必填项，请填写信息'}]}]" />
                </a-form-item>
              </a-col>
              <a-col :span="12" v-if="false">
                <a-form-item label="价格参考期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-range-picker
                    @change="time"
                    format="YYYY-MM-DD"
                    v-decorator="['price_reference_period', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                    <template slot="dateRender" slot-scope="current">
                      <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                        {{ current.date() }}
                      </div>
                    </template>
                  </a-range-picker>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="计价币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'pricing_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                @change="pricingCurrencyChange"
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="收款币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'receive_pricing_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] === '1' && false">
            <a-form-item label="采购合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number allow-clear v-decorator="['purchase_settlement_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" />
              <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] === '2' && false">
            <a-form-item label="销售结算金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number allow-clear v-decorator="['sales_settlement_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]">
              </a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="false">
            <a-form-item label="汇率" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'exchange_rate',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                allow-clear
                @change="exchangeRateChange"
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.exchange_rate">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :offset="1" :span="23" class="hidden_item" v-if="false && selectedExchangeRate > 0">
            <a-divider orientation="left" dashed>{{ exchangeRateTitle }}</a-divider>
            <a-form-item label="固定汇率" v-if="selectedExchangeRate === 1" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 60%" allow-clear v-decorator="['fixed_exchange_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
            <a-row v-if="selectedExchangeRate === 2">
              <a-col :span="10">
                <a-form-item label="日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-date-picker
                    v-decorator="['fixed_date_rate', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                    format="YYYY-MM-DD"
                    value-format="yyyy-MM-DD"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="10">
                <a-form-item label="汇率定义方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input v-decorator="['exchange_rate_definition', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="汇率定义方式" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="其他日期汇率" v-if="selectedExchangeRate === 3" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 60%" allow-clear v-decorator="['fixed_exchange_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="false">
            <a-form-item label="是否有临时单价" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'is_temp_unit_price',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                @change="isTempUnitPriceChange">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.is_temp_unit_price">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false && isSelectedTempUnitPrice >= 1">
            <a-form-item label="临时单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number allow-clear v-decorator="['temp_unit_price', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="false">
            <a-form-item label="是否有临时汇率" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'is_temp_exchange_rate',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                @change="isTempExchangeRateChange">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.is_has">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false && isSelectedTempExchangeRate === 1">
            <a-form-item label="临时汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number allow-clear v-decorator="['temp_exchange_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="false">
            <a-form-item label="是否有临时合同金额" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'is_temp_contract_amount',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                @change="isTempContractAmountChange">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.is_has">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false && isSelectedTempContractAmount === 1">
            <a-form-item label="临时合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number allow-clear v-decorator="['temp_contract_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              付款方式
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="预付款方式" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                allow-clear
                @change="paymentMethodChange"
                placeholder="选择"
                v-decorator="[
                  'payment_method',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ]
                  }
                ]">
                <a-select-option :value="index" v-for="(item, index) in this.$Dictionaries.trade_pre_payment_method" :key="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :offset="2" :span="20" class="hidden_item" v-if="paymentMethod > 0">
            <a-divider orientation="left" dashed>{{ paymentMethodTitle }}</a-divider>
            <a-row>
              <a-col :span="12">
                <a-form-item label="预付款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number @change="prePaymentChange" style="width: 25%" allow-clear v-decorator="['pre_payment', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
                  <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.receivedPricingCurrency] }}</span>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="预付款支付期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-date-picker
                    v-decorator="['pre_payment_date', {rules: [{required: prePayment > 0, message: '必填项，请填写信息'}]}]"
                    format="YYYY-MM-DD"
                    value-format="yyyy-MM-DD"
                  /> 前
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="24" v-if="false">
            <a-form-item label="尾款方式" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                allow-clear
                @change="balancePaymentMethodChange"
                placeholder="选择"
                v-decorator="[
                  'balance_payment_method',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ]
                  }
                ]">
                <a-select-option :value="index" v-for="(item, index) in this.$Dictionaries.trade_balance_payment_method" :key="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :offset="2" :span="20" class="hidden_item" v-if="balancePaymentMethod > 0 && balancePaymentMethod !== 6">
            <a-divider orientation="left" dashed> {{ balancePaymentMethodTitle }}</a-divider>
            <a-row>
              <a-col :span="12">
                <a-form-item label="尾款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number @change="balancePaymentChange" style="width: 25%" allow-clear v-decorator="['balance_payment', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
                  <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="尾款支付期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-select
                    style="width: 80%"
                    v-decorator="[
                      'trade_balance_payment_date_method',
                      {
                        rules: [
                          { required: balancePayment !== 0, message: '请选择' }
                        ],
                      },
                    ]"
                    placeholder="选择"
                    allow-clear
                    @change="tradeBalancePaymentTimeChange"
                    option-filter-prop="children"
                    :filter-option="filterOption">
                    <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_balance_payment_date_method">{{ val }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12" v-if="tradeBalancePaymentTimeMethod === 1">
                <a-form-item label="确定尾款日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-date-picker
                    v-decorator="['balance_payment_date', {rules: [{required: tradeBalancePaymentTimeMethod === 1, message: '必填项，请填写信息'}]}]"
                    format="YYYY-MM-DD"
                    placeholder="尾款日期"
                    value-format="yyyy-MM-DD"
                  /> 前
                </a-form-item>
              </a-col>
              <a-col :span="12" v-if="tradeBalancePaymentTimeMethod === 2">
                <a-form-item label="承兑日后" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input-number allow-clear v-decorator="['trade_balance_payment_days', {initialValue: 0, rules: [{required: tradeBalancePaymentTimeMethod === 2, message: '必填项，请填写信息'}]}]"/> （天）
                </a-form-item>
              </a-col>
              <a-col :span="12" v-if="tradeBalancePaymentTimeMethod === 3">
                <a-form-item label="不确定尾款日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                  <a-input allow-clear v-decorator="['unbalance_payment_date_desc', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              货转信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="备案仓库" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="warehouseFetching ? undefined : null"
                show-search
                v-decorator="[
                  'warehouse_id',
                  {
                    rules: [
                      { required: false, message: '选择项目' },
                    ],
                  },
                ]"
                placeholder="请输入仓库名称"
                @search="this.warehouseSearch"
                @change="handleTradeWarehouseChange"
              >
                <a-spin v-if="warehouseFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in tradeWarehouseList" :key="d.id">
                  {{ d.name }}（{{ d.location }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="model['type'] === '1' ?'入库货转类型' : '出库货转类型'" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                allow-clear
                @change="handleStockTransferTypeChange"
                placeholder="选择"
                v-decorator="[
                  'warehouse_stock_transfer_type',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ]
                  }
                ]">
                <a-select-option :value="index" v-for="(item, index) in this.$Dictionaries.trade_warehouse_stock_transfer_types" :key="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="stockTransferType === 1">
            <a-form-item label="货转前提条件" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                style="width: 50%"
                allow-clear
                @change="handlePrerequisityGoodsTransferChange"
                placeholder="选择"
                v-decorator="[
                  'goods_transfer_prerequisity',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ]
                  }
                ]">
                <a-select-option :value="index" v-for="(item, index) in this.$Dictionaries.trade_sell_contract_goods_transfer_prerequisites" :key="index">
                  {{ item }}
                </a-select-option>
              </a-select>
              <a-input-number
                style="width: 30%"
                v-if="goodsTransferPrerequisity >= 1"
                v-decorator="[
                  'postpone_days',
                  {
                    rules: [
                      { required: goodsTransferPrerequisity >= 1, message: '请选择' }
                    ]
                  }
                ]"
                placeholder="请输入天数"/>
              <a-select
                v-decorator="[
                  'postpone_days_type',
                  {
                    rules: [
                      { required: goodsTransferPrerequisity >= 1, message: '请选择' }
                    ]
                  }
                ]"
                v-show="goodsTransferPrerequisity >= 1"
                default-value="2"
                style="width: 20%"
                placeholder="选择">
                <a-select-option value="1">
                  天
                </a-select-option>
                <a-select-option value="2">
                  工作日
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="stockTransferType === 2">
            <a-form-item label="货转后约束条件" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input allow-clear v-decorator="['constraints', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="提货期" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                allow-clear
                @change="handleDeliveryPeriodTypeChange"
                placeholder="选择"
                v-decorator="[
                  'delivery_period_type',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ]
                  }
                ]">
                <a-select-option :value="index" v-for="(item, index) in this.$Dictionaries.trade_delivery_period_types" :key="index">
                  {{ item }}
                </a-select-option>
              </a-select>
              <a-input-number
                style="width: 30%"
                v-if="deliveryPeriodType !== 6 && deliveryPeriodType > 0"
                v-decorator="[
                  'delivery_period_postpone_days',
                  {
                    rules: [
                      { required: deliveryPeriodType !== 6, message: '请选择' }
                    ]
                  }
                ]"
                placeholder="请输入超期天数"/>
              <a-select
                v-decorator="[
                  'delivery_period_postpone_days_type',
                  {
                    rules: [
                      { required: deliveryPeriodType !== 6, message: '请选择' }
                    ]
                  }
                ]"
                v-if="deliveryPeriodType !== 6 && deliveryPeriodType > 0"
                default-value="2"
                style="width: 20%"
                placeholder="选择">
                <a-select-option value="1">
                  天
                </a-select-option>
                <a-select-option value="2">
                  工作日
                </a-select-option>
              </a-select>
              <span v-if="deliveryPeriodType !== 6 && deliveryPeriodType > 0" style="padding-left: 5px">内提完</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="deliveryPeriodType !== 6 && deliveryPeriodType > 0">
            <a-form-item label="超期责任人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-if="false" allow-clear v-decorator="['undertaking_party', {rules: [{required: stockTransferType === 2, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                v-decorator="[
                  'undertaking_party_id',
                  {
                    rules: [
                      { required: false, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请输入"
                :default-active-first-option="false"
                @search="this.clientSearch"
              >
                <a-select-option v-for="d in clientList" :key="d.client_id" :tt="d.client">
                  {{ d.client }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              结算信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="结算量" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'settlement_volume',
                  {
                    rules: [
                      { required: false, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="选择"
                @change="handleTradeSettlementVolumeChange"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in settlementVolumeList">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-show="customSettlementVolume === 5">
            <a-form-item label="结算量名称" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input allow-clear v-decorator="['custom_settlement_volume', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="customSettlementVolume > 0">
            <a-form-item label="结算量内容" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-modal :visible="settlementVolumeVisible" @ok="addCustomSettlementVolume" @cancel="settlementVolumeVisible=false" title="添加">
                <a-input :maxLength="32" allow-clear placeholder="请输入" v-model="custom_settlement_volume_content"/>
              </a-modal>
              <a-button style="margin-right: 10px" @click="settlementVolumeVisible=true" v-show="customSettlementVolume === 5">
                添加
                <span v-if="settlementVolumeContentList.length > 0">[{{ settlementVolumeContentList.length }}]</span>
              </a-button>
              <div v-if="settlementVolumeContentList.length > 0">
                <a-tag v-for="(value) in settlementVolumeContentList" :key="value.key" :closable="customSettlementVolume === 5" @close="deleteCustomSettlementVolumeContent(value.key)">{{ value.name }}</a-tag>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开启审批" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="合同附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
            </a-form-item>
          </a-col>
          <a-col :offset="2" :span="20" v-if="otherData.attachment.length > 0">
            <a-table
              bordered
              :data-source="otherData.attachment"
              :columns="attachmentColumns"
              v-if="this.otherData.attachment.length > 0"
              :pagination="false"
              key="key">
              <template slot="action" slot-scope="text, record">
                <a-popconfirm
                  v-if="otherData.attachment.length"
                  title="确定删除?"
                  @confirm="() => onAttachmentDelete(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </a-col>
        </a-row>
      </a-form>
      <component
        :ref="currentComponent"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :is="currentComponent"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="mdl"></component>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import moment from 'moment'
import KeyPointCreateForm from '../keypoint/modules/CreateForm'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import FixedPriceForm from './FixedPriceForm'
import ValenceOfVertexForm from './ValenceOfVertexForm'
import UnitPriceForm from './UnitPriceForm'
import FloatingPriceForm from './FloatingPriceForm'
import ExchangeRateForm from './ExchangeRateForm'
import PaymentMethodForm from './PaymentMethodForm'
import TurningMonthForm from './TurningMonthForm'
import CreateProductParameterForm from '../../product_parameter/modules/CreateForm'
import ChooseContractNumberForm from './ChooseContractNumberForm'
import { project_client_list } from '@/api/trade_project_client'
import { project_list } from '@/api/trade_project'
import { warehouse_list } from '@/api/trade_warehouse'
import { tradeGenerateContractNumber } from '@/utils/util'
// 表单字段
const fields = ['id', 'host_corporation_id', 'category_id', 'number', 'name', 'credit', 'cash']
export default {
  components: {
    KeyPointCreateForm,
    AttachmentCreateForm,
    FixedPriceForm,
    ValenceOfVertexForm,
    UnitPriceForm,
    FloatingPriceForm,
    ExchangeRateForm,
    PaymentMethodForm,
    TurningMonthForm,
    CreateProductParameterForm,
    ChooseContractNumberForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.tradeProjectSearch = debounce(this.handleTradeProjectSearch, 800)
    this.clientSearch = debounce(this.handleClientSearch, 800)
    this.warehouseSearch = debounce(this.handleWarehouseSearch, 800)
    return {
      formLayout: 'horizontal',
      tradeTypes: this.$Dictionaries.trade_types,
      projectFetching: false,
      warehouseFetching: false,
      unit_price_type: Object.fromEntries(
        Object.entries(this.$Dictionaries.unit_price_type).filter(([key, value]) => key !== '0')
      ),
      tradeProjectList: [],
      tradeWarehouseList: [],
      selectedProjectId: undefined,
      selectedProject: undefined,
      clientList: [],
      currentComponent: '',
      selectedUnitPrice: 0,
      selectedExchangeRate: 0,
      isSelectedTempUnitPrice: 0, // 是否有临时单价
      isSelectedTempExchangeRate: 0, // 是否有临时汇率
      isSelectedTempContractAmount: 0, // 是否有临时合同金额
      paymentMethod: 0, // 支付方式
      balancePaymentMethod: 0, // 尾款支付方式
      tradeBalancePaymentTimeMethod: 0, // 支付方式
      stockTransferType: 0, // 入库货转类型
      goodsTransferPrerequisity: 0, // 货转前提条件
      settlementVolumeList: this.$Dictionaries.trade_settlement_volume,
      deliveryPeriodType: 0, // 提货期
      tradeSettlementVolumeContent: { 1: '毛重, 净重, 毛桶, 净桶', 2: '毛重, 净重, 毛桶, 净桶', 3: '毛重, 净重, 毛桶, 净桶', 4: '毛重, 净重' },
      settlementVolumeContentList: [],
      custom_settlement_volume_content: undefined,
      settlementVolumeVisible: false,
      customSettlementVolume: 0,
      prePayment: 0, // 预付款
      balancePayment: 0, // 尾款
      tradeType: -1, // 贸易类型
      pricingCurrency: undefined,
      receivedPricingCurrency: undefined,
      visibleFrom: false,
      confirmLoadingFrom: false,
      generateLoading: false,
      moreContractNumberVisible: false,
      mdl: {},
      param: {},
      form: this.$form.createForm(this),
      otherData: {
        key_point: [],
        attachment: [],
        turning_month_list: [],
        product_parameters: []
        // exchange_rate_data: {
        //   fixed: undefined,
        //   un_fixed: undefined,
        //   fixed_date: undefined
        // },
        // payment_method_data: {
        //   pre: undefined,
        //   balance: undefined
        // }
      },
      isTurningMonth: false,
      turningMonthList: [],
      turningMonthColumns: [
        {
          title: '序号',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '转月后期货合约',
          dataIndex: 'futures_contract',
          width: 150,
          align: 'center',
          ellipsis: true,
          customRender: (text) => text.substring(0, text.lastIndexOf('-'))
        },
        {
          title: '转月后默认计价期',
          dataIndex: 'pricing_period_start_date',
          ellipsis: true,
          align: 'center',
          customRender: (text, obj) => text + '~' + obj.pricing_period_end_date
        },
        {
          title: '转月后锁价期限',
          dataIndex: 'lock_up_date',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          width: 100,
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      keyPointColumns: [
        {
          title: '名称',
          dataIndex: 'key',
          scopedSlots: { customRender: 'key' }
        },
        {
          title: '内容',
          dataIndex: 'value',
          scopedSlots: { customRender: 'value' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      attachmentColumns: [
        {
          title: '名称',
          width: 150,
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      parameterColumns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true
        },
        {
          title: '符号',
          dataIndex: 'symbol',
          width: 160,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_value_compare_symbol[text] || '无'
        },
        {
          title: '值',
          dataIndex: 'standard_value',
          width: 160,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    },
    title () {
      if (this.model['type'] === '1') {
        return '新建采购合同'
      } else {
        return '新建销售合同'
      }
    },
    exchangeRateTitle () {
      if (this.selectedExchangeRate === 1) {
        return '汇率-固定汇率'
      } else if (this.selectedExchangeRate === 2) {
        return '汇率-日期'
      } else if (this.selectedExchangeRate === 3) {
        return '汇率-其他日期汇率'
      }
      return ''
    },
    paymentMethodTitle () {
      if (this.paymentMethod <= 5) {
        return '付款方式-预付款支付-' + this.$Dictionaries.trade_pre_payment_method[this.paymentMethod]
      }
      return ''
    },
    balancePaymentMethodTitle () {
      if (this.paymentMethod > 5) {
        return '付款方式-尾款支付-' + this.$Dictionaries.trade_balance_payment_method[this.paymentMethod]
      }
      return ''
    }
  },
  methods: {
    moment,
    handleTradeProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.tradeProjectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    randomNumber () {
      const current_date = new Date()
      const random = Math.floor(Math.random() * 100000)
      return current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds() + '' + random
    },
    handleWarehouseSearch (value) {
      this.warehouseFetching = true
      warehouse_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.tradeWarehouseList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.warehouseFetching = false
      })
    },
    handleTradeProjectChange (value) {
      if (value === undefined) {
        this.handleTradeProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.selectedProject = this.tradeProjectList.filter(item => item.id === this.selectedProjectId)[0]
        this.handleClientSearch(undefined)
      }
    },
    handleTradeWarehouseChange (value) {
      if (value === undefined) {
        this.handleWarehouseSearch(value)
      }
    },
    handleClientSearch (value) {
      if (this.selectedProjectId === undefined) {
        return
      }
      project_client_list({ name: value, project_id: this.selectedProjectId }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    time (dates, dateStrings) {
      this.param.start_date = dateStrings[0]
      this.param.end_date = dateStrings[1]
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    addTurningMonth (v) {
      if (!v) {
        this.turningMonthList = []
      }
      this.currentComponent = 'TurningMonthForm'
      this.mdl['size'] = this.turningMonthList.length
      this.visibleFrom = v
      this.isTurningMonth = v
    },
    handleTurningMonthChange (v) {
      this.isTurningMonth = v
    },
    onDeleteItem (key) {
      const dataSource = [...this.turningMonthList]
      this.turningMonthList = dataSource.filter(item => item.key !== key)
    },
    handleClientChange (value) {
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    handleTradeTypeChange (value) {
      if (value !== undefined) {
        this.tradeType = Number(value)
      } else {
        this.tradeType = -1
      }
    },
    handleAddKeyPoint () {
      this.currentComponent = 'KeyPointCreateForm'
      this.visibleFrom = true
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    tradeBalancePaymentTimeChange (v) {
      if (v !== undefined) {
        this.tradeBalancePaymentTimeMethod = Number(v)
      } else {
        this.tradeBalancePaymentTimeMethod = 0
      }
    },
    handleStockTransferTypeChange (v) {
      if (v !== undefined) {
        this.stockTransferType = Number(v)
      } else {
        this.stockTransferType = 0
      }
    },
    handleDeliveryPeriodTypeChange (v) {
      if (v !== undefined) {
        this.deliveryPeriodType = Number(v)
      } else {
        this.deliveryPeriodType = 0
      }
    },
    handlePrerequisityGoodsTransferChange (v) {
      if (v !== undefined) {
        this.goodsTransferPrerequisity = Number(v)
      } else {
        this.goodsTransferPrerequisity = 0
      }
    },
    handleTradeSettlementVolumeChange (v) {
      this.customSettlementVolume = parseInt(v)
      if (this.customSettlementVolume in this.tradeSettlementVolumeContent) {
        this.settlementVolumeContentList = this.tradeSettlementVolumeContent[this.customSettlementVolume].split(',') || []
        if (this.settlementVolumeContentList.length > 0) {
          this.settlementVolumeContentList = this.settlementVolumeContentList.map(item => {
            const data = {
              name: item,
              key: this.randomNumber()
            }
            return data
          })
        }
      } else {
        this.settlementVolumeContentList = []
      }
    },
    addCustomSettlementVolume () {
      if (this.custom_settlement_volume_content !== undefined && this.customSettlementVolumeContent !== '') {
        const exists = this.customSettlementVolumeContent.some(item => item.name === this.custom_settlement_volume_content)
        if (exists) {
          this.$message.warning('内容重复')
          return
        }
        this.settlementVolumeContentList.push({
          name: this.custom_settlement_volume_content,
          key: this.randomNumber()
        })
        this.custom_settlement_volume_content = undefined
        this.settlementVolumeVisible = false
      } else {
        this.$message.warning('输入内容')
      }
    },
    deleteCustomSettlementVolumeContent (key) {
      this.settlementVolumeContentList = this.settlementVolumeContentList.filter(item => item.key !== key)
    },
    onKeyPointDelete (key) {
      const dataSource = [...this.otherData.key_point]
      this.otherData.key_point = dataSource.filter(item => item.keys !== key)
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddAttachment () {
      this.currentComponent = 'AttachmentCreateForm'
      this.visibleFrom = true
    },
    handleAddCancel () {
      this.visibleFrom = false
      this.mdl = {}
      const form = this.$refs[this.currentComponent].form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (data) {
      const form = this.$refs[this.currentComponent].form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, data)
          // 新增
          if (this.currentComponent === 'KeyPointCreateForm') {
            values.keys = this.randomNumber()
            this.otherData.key_point.push(values)
          } else if (this.currentComponent === 'AttachmentCreateForm') {
            values.url = values.url.fileList[0].url
            values.key = this.randomNumber()
            this.otherData.attachment.push(values)
          } else if (this.currentComponent === 'TurningMonthForm') {
            const start_date = values['pricing_period'][0].format('YYYY-MM-DD')
            const end_date = values['pricing_period'][1].format('YYYY-MM-DD')
            values['pricing_period'] = undefined
            values['pricing_period_start_date'] = start_date
            values['pricing_period_end_date'] = end_date
            values.key = this.randomNumber()
            this.turningMonthList.push(values)
            form.resetFields()
          } else if (this.currentComponent === 'CreateProductParameterForm') {
            this.otherData.product_parameters = this.composeData(data, this.otherData.product_parameters)
          } else if (this.currentComponent === 'ChooseContractNumberForm') {
            this.form.setFieldsValue({
              contract_number: values['contract_number']
            })
          }
          this.visibleFrom = false
          form.resetFields()
        } else {
          this.confirmLoading = false
        }
      })
    },
    composeData (newList, oldList) {
     if (oldList === undefined || oldList.length === 0) {
        return newList
      } else {
       const seen = new Set()
       newList.forEach(item => {
         if (item.name) {
           seen.add(item.name)
         }
       })
       const filteredOldList = oldList.filter(item => item.name && !seen.has(item.name))
       return [...filteredOldList, ...newList]
     }
    },
    ok () {
      if (this.otherData.key_point) {
        this.otherData.key_point = this.otherData.key_point.map(item => {
          item.keys = undefined
          return item
        })
      }
      if (this.otherData.attachment) {
        this.otherData.attachment = this.otherData.attachment.map(item => {
          item.key = undefined
          return item
        })
      }
      if (this.selectedUnitPrice === 2 && this.turningMonthList.length > 0) {
        this.otherData.turning_month_list = this.turningMonthList
      }
      this.otherData['type'] = this.model['type']

      // 结算信息
      if (this.settlementVolumeContent !== undefined && this.settlementVolumeContent.length > 0) {
        this.otherData['settlement_volume_content'] = this.settlementVolumeContent
      }
      this.$emit('ok', this.otherData)
    },
    unitPriceChange (v) {
      if (v !== undefined) {
        this.selectedUnitPrice = Number(v)
      } else {
        this.selectedUnitPrice = 0
      }
      this.receivedPricingCurrency = undefined
    },
    exchangeRateChange (v) {
      if (v !== undefined) {
        this.selectedExchangeRate = Number(v)
      } else {
        this.selectedExchangeRate = 0
      }
    },
    isTempUnitPriceChange (v) {
      if (v !== undefined) {
        this.isSelectedTempUnitPrice = Number(v)
      } else {
        this.isSelectedTempUnitPrice = 0
      }
    },
    isTempExchangeRateChange (v) {
      if (v !== undefined) {
        this.isSelectedTempExchangeRate = Number(v)
      } else {
        this.isSelectedTempExchangeRate = 0
      }
    },
    isTempContractAmountChange (v) {
      if (v !== undefined) {
        this.isSelectedTempContractAmount = Number(v)
      } else {
        this.isSelectedTempContractAmount = 0
      }
    },
    paymentMethodChange (v) {
      if (v !== undefined) {
        this.paymentMethod = Number(v)
      } else {
        this.paymentMethod = 0
      }
    },
    balancePaymentMethodChange (v) {
      if (v !== undefined) {
        this.balancePaymentMethod = Number(v)
      } else {
        this.balancePaymentMethod = 0
      }
    },
    addProductParameter () {
      // this.$router.push({ path: '/trade/' + record.id + '/product_parameter', query: { name: record.name } })
      this.currentComponent = 'CreateProductParameterForm'
      if (this.selectedProject !== undefined && this.selectedProject['category'] !== undefined) {
        this.mdl['name'] = this.selectedProject['category']
      }
      this.visibleFrom = true
    },
    onParameterDelete (key) {
      this.otherData.product_parameters = this.otherData.product_parameters.filter(product => {
        return product.key !== key
      })
    },
    prePaymentChange (value) {
      this.prePayment = value
    },
    balancePaymentChange (value) {
      this.balancePayment = value
    },
    pricingCurrencyChange (value) {
      this.pricingCurrency = value
    },
    receivedPricingCurrencyChange (value) {
      this.receivedPricingCurrency = value
    },
    generateContractNumber () {
      if (this.selectedProjectId === undefined) {
        this.$message.warning('选择采销全流程')
        return
      }
      this.generateLoading = true
      tradeGenerateContractNumber(this, this.selectedProjectId, () => {
        this.generateLoading = false
      }).then(data => {
        if (typeof data === 'object') {
          if (data.length === 1) {
            this.form.setFieldsValue({
              contract_number: '' + data[0]['contract_number']
            })
          } else {
            this.visibleFrom = true
            this.currentComponent = 'ChooseContractNumberForm'
            this.mdl['list'] = data
          }
        } else {
          this.form.setFieldsValue({
            contract_number: '' + data
          })
        }
      })
    }
  }
}
</script>
<style scoped>

.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}

.hidden_item {
  border: 1px solid #eeeeee;
  /*background-color: #efefef6a;*/
  padding: 10px;
  margin-bottom: 10px;
}
</style>
